/* R•ALY — sincroniza pontinhos do mini-carrossel dos cards com o swipe.
   O swipe em si é feito por scroll-snap nativo (robusto). Aqui só atualizamos
   o pontinho ativo conforme o slide central e permitimos clicar no pontinho. */
(function () {
  function initGallery(gallery) {
    if (gallery.dataset.ralyInit === '1') return;
    gallery.dataset.ralyInit = '1';

    var track = gallery.querySelector('.raly-cm__track');
    var dotsWrap = gallery.querySelector('.raly-cm__dots');
    if (!track || !dotsWrap) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('.raly-cm__slide'));
    var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.raly-cm__dot'));
    if (slides.length < 2) return;

    // Setas de navegação (padrão robusto, igual ao UGC)
    function goTo(i) {
      var idx = Math.max(0, Math.min(slides.length - 1, i));
      if (slides[idx]) track.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
    }
    function currentIndex() {
      var center = track.scrollLeft + track.clientWidth / 2, best = 0, bd = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var sc = slides[i].offsetLeft + slides[i].offsetWidth / 2, d = Math.abs(sc - center);
        if (d < bd) { bd = d; best = i; }
      }
      return best;
    }
    var navPrev = document.createElement('button');
    var navNext = document.createElement('button');
    navPrev.type = 'button'; navNext.type = 'button';
    navPrev.className = 'raly-cm__nav raly-cm__nav--prev';
    navNext.className = 'raly-cm__nav raly-cm__nav--next';
    navPrev.setAttribute('aria-label', 'Imagem anterior');
    navNext.setAttribute('aria-label', 'Próxima imagem');
    navPrev.innerHTML = '‹'; navNext.innerHTML = '›';
    function stop(e){ e.preventDefault(); e.stopPropagation(); }
    ['pointerdown','mousedown','touchstart','click'].forEach(function (evt) {
      navPrev.addEventListener(evt, function (e) { stop(e); if (evt === 'click') goTo(currentIndex() - 1); }, true);
      navNext.addEventListener(evt, function (e) { stop(e); if (evt === 'click') goTo(currentIndex() + 1); }, true);
    });

    var raf = null;
    function updateActive() {
      raf = null;
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var s = slides[i];
        var sc = s.offsetLeft + s.offsetWidth / 2;
        var d = Math.abs(sc - center);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      for (var j = 0; j < dots.length; j++) {
        dots[j].classList.toggle('is-active', j === best);
      }
    }

    track.addEventListener('scroll', function () {
      if (raf == null) raf = requestAnimationFrame(updateActive);
    }, { passive: true });

    dots.forEach(function (dot, i) {
      dot.style.pointerEvents = 'auto';
      dot.style.cursor = 'pointer';
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (slides[i]) {
          track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        }
      });
    });

    // Arraste com ponteiro (mouse no desktop) além do swipe nativo por toque
    var dragging = false, startX = 0, startScroll = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      dragging = true; moved = false;
      startX = e.clientX; startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startScroll - dx;
    });
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      // snap para o slide mais próximo
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var sc = slides[i].offsetLeft + slides[i].offsetWidth / 2;
        var d = Math.abs(sc - center);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      if (slides[best]) track.scrollTo({ left: slides[best].offsetLeft, behavior: 'smooth' });
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', endDrag);
    // se arrastou, cancela o clique no link do slide (não abrir produto sem querer)
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    updateActive();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-raly-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Reprocessa quando o editor do tema recarrega uma seção
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
